import React from "react";
import PublicBookJournalCatalog from "../components/learner/PublicBookJournalCatalog";

/** Public journal marketplace listing; authentication is required at checkout. */
const Journals = () => <PublicBookJournalCatalog kind="journal" />;

export default Journals;
